import { render } from "./FormModel.vue?vue&type=template&id=cba8437a"
import script from "./FormModel.vue?vue&type=script&lang=js"
export * from "./FormModel.vue?vue&type=script&lang=js"

import "./FormModel.vue?vue&type=style&index=0&id=cba8437a&lang=less"

import exportComponent from "/home/jpom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__